<template>
  <!-- ブラウザ自動翻訳による月ラベル(年月・曜日・日付)の破壊を防ぐため翻訳対象外にする。詳細は DatePickerCalendar.vue のコメント参照 -->
  <div class="notranslate w-full border font-Spectral" data-testid="calendar" translate="no" :class="props.isError ? 'border-red-500 bg-red-50' : 'bg-[#F4F1ED]'">
    <div class="flex items-center justify-between py-2">
      <button class="mt-1 rounded-lg p-3 hover:bg-gray5" data-testid="prev-month-button" type="button" @click="onClickPrevButton">
        <img alt="前の月" class="rotate-180" src="@/assets/icon/right/gold.svg" />
      </button>

      <AtomsHeading2 class="text-neutral-600">{{ selectedYearMonth }}</AtomsHeading2>
      <button class="mt-0.5 rounded-lg p-3 hover:bg-gray5" data-testid="next-month-button" type="button" @click="onClickNextButton">
        <img alt="次の月" src="@/assets/icon/right/gold.svg" />
      </button>
    </div>
    <div class="grid grid-cols-7 border-b">
      <div v-for="day in props.lang === 'jp' ? WEEKDAY_LIST : WEEKDAY_LIST_EN" :key="day" class="flex justify-center">
        <AtomsParagraph4>
          <span>
            {{ day }}
          </span>
        </AtomsParagraph4>
      </div>
    </div>
    <div v-for="(week, i) in calendarRowList" :key="i" class="grid grid-cols-7 border-b">
      <div v-for="({ day, isCurrentMonth }, j) in week" :key="'week' + j">
        <div>
          <slot name="content" :day="day" :is-current-month="isCurrentMonth" :selected-year-month="selectedYearMonth" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useCalendar } from '@/composables/ui/useCalendar';
import type { Lang } from '@/models/lang';
import { getCurrentJstDayjs } from '@/utils/date';
import { WEEKDAY_LIST, WEEKDAY_LIST_EN } from '@/wabunka-src/constants/calendar';

import type dayjs from 'dayjs';

interface Props {
  day?: dayjs.Dayjs;
  isError?: boolean;
  lang?: Lang;
}

const props = withDefaults(defineProps<Props>(), {
  day: () => getCurrentJstDayjs(),
  lang: 'jp',
});

/** カレンダー描画用 */
const {
  selectedYearMonth,
  calendarRowList,
  startDate,
  endDate,

  onClickPrevButton,
  onClickNextButton,
} = useCalendar(
  toRef(() => props.day),
  props.lang,
);

interface Emit {
  (e: 'onChange', startDate: string, endDate: string): void;
}

const emit = defineEmits<Emit>();

watch(
  [startDate, endDate],
  async ([s, e], [oldS, oldE]) => {
    const newStart = s.format('YYYY-MM-DD');
    const newEnd = e.format('YYYY-MM-DD');
    if (newStart === oldS?.format('YYYY-MM-DD') && newEnd === oldE?.format('YYYY-MM-DD')) return;
    emit('onChange', newStart, newEnd);
  },
  { immediate: true },
);
</script>
